import { render, staticRenderFns } from "./EDrawerHistoricoAulaLancada.vue?vue&type=template&id=440a378b&scoped=true"
import script from "./EDrawerHistoricoAulaLancada.vue?vue&type=script&lang=js"
export * from "./EDrawerHistoricoAulaLancada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440a378b",
  null
  
)

export default component.exports